import {useEffect} from 'react'

import {V2_FIELDS} from '../schema/contactSchema.js'

export const usePresetMessageSync = ({presetMessage, form}) => {
  useEffect(() => {
    if (presetMessage) form.setFieldValue(V2_FIELDS.MESSAGE, presetMessage)
  }, [presetMessage, form])
}

export default usePresetMessageSync
